import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin'
import {Link} from 'react-router-dom'

import {getRequest, obj2params} from "../../util/utils";
class Header extends Component {
    constructor(props, context) {
        super(props, context);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        var left = window.innerWidth*0.8;
        var marginLeft = left+'px';
        return (

            <div className="header">


                <div className="logo" >
                    <Link  to={"/?" + obj2params(getRequest())} ><p style={{ fontSize: 28} }>图书馆精确查询系统</p></Link>



                </div>


            </div>

        )
    }



}



export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js